import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { AccountService } from '../../services/account.service';
import { SessionService } from '../../services/session.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-users-list',
  imports: [ CommonModule, FormsModule, ReactiveFormsModule,CardModule,
    ButtonModule, BadgeModule, AvatarModule, InputTextModule, SelectModule,
    InputGroupModule, InputGroupAddonModule, PasswordModule
  ],
  templateUrl: './users-list.html',
  styleUrl: './users-list.css'
})
export class UsersList implements OnInit {
  public usersList: any[] = [];
  public selectedUser: any = null;
  public drawerOpen = false;
  public totalUsers: number = 0;
  public totalActiveUsers: number = 0;
  public totalAdmins: number = 0;
  public totalTenants: number = 0;
  public userForm: FormGroup;
  public userTypeOptions: any[] = [];
  public formMode: string = 'add';
  // Filter and search
  searchTerm = '';
  filterRole = 'all';
  filterStatus = 'all';

  constructor(
    private accountService: AccountService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private sessionService: SessionService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) { 
    this.userForm = this.fb.group({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl(''),
      userEmail: new FormControl('', [Validators.email, Validators.required]),
      mobileNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
      userType: new FormControl('', Validators.required),
      tenants: new FormControl(''),
      userPassword: new FormControl('')
    });
    this.userTypeOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Manager', value: 'manager' },
      { label: 'User', value: 'executive' },
    ];
  }



  // Filter options

  ngOnInit() {
    // Initialize component
    this.getUsersList();
  }

  getUsersList() {
    this.spinner.show();
    this.accountService.fetchAdditionalUsers(this.sessionService.getAccountId()).subscribe((res: any) => {
      console.log(res);
      if (res.success == true && res.data != null) {
        this.usersList = res.data.users;
        this.totalUsers = res.data.totalUsers;
        this.totalActiveUsers = res.data.totalActiveUsers;
        this.totalAdmins = res.data.totalAdmins;
        this.totalTenants = res.data.totalTenants;
        this.cdr.markForCheck();
      } else {
        this.usersList = [];
        this.totalUsers = 0;
        this.totalActiveUsers = 0;
        this.totalAdmins = 0;
        this.totalTenants = 0;
        this.cdr.markForCheck();
      }
      this.spinner.hide();
    }, (err: any) => {
      this.spinner.hide();
      this.usersList = [];
      this.totalUsers = 0;
      this.totalActiveUsers = 0;
      this.totalAdmins = 0;
      this.totalTenants = 0;
      this.cdr.markForCheck();
      this.toastr.error('Unable to fetch users list');
    });
  }

  get filteredUsers(): any[] {
    return this.usersList.filter((user: any) => {
      const matchesSearch = 
        user.firstName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.lastName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.userEmail.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.mobileNumber.includes(this.searchTerm);
      
      const matchesStatus = this.filterStatus === 'all' || 
        (this.filterStatus === 'active' ? user.isActive : !user.isActive);
      
      return matchesSearch && matchesStatus;
    });
  }

  addUser() {
    this.drawerOpen = true;
    this.formMode = 'add';
    this.cdr.markForCheck();
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.userForm.patchValue(user);
    this.formMode = 'edit';
    this.drawerOpen = true;
  }

  closeDrawer() {
    this.drawerOpen = false;
    this.selectedUser = null;
    this.formMode = 'add';
  }
  
  generatePassword() {
    const password = Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
    this.userForm.patchValue({ userPassword: password });
  }

  getStatusBadgeClass(isActive: boolean): string {
    return isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800';
  }

  getInitials(firstName: string, lastName: string): string {
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  }

  sendInvitation() {
    if (this.userForm.valid) {
      const accountid = this.sessionService.getAccountId();
      const userobj: any = {
        firstName: this.userForm.value.firstName,
        lastName: this.userForm.value.lastName,
        userEmail: this.userForm.value.userEmail,
        mobileNumber: this.userForm.value.mobileNumber,
        userType: this.userForm.value.userType,
        tenants: this.userForm.value.tenants
      }
      this.spinner.show();
      this.accountService.addAdditionalUser(accountid, userobj).subscribe((res: any) => {
        this.spinner.hide();
        if (res.success == true) {
          this.toastr.success('Invitation sent successfully');
          this.closeDrawer();
          this.getUsersList();
        } else {
          this.toastr.error(res.message);
        }
      }, (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.message);
      });
    }
  }

  updateUser() {

  }
 
}